module.exports = __webpack_public_path__ + "static/media/monkey2@3x.e50d5db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/monkey2@3x.png
// module id = 765
// module chunks = 0